import { CardsSection } from "components/layout/Section/CardsSection"
import { useGenericSurvey } from "features/subscription-process/profiling-process/hooks/useGenericSurvey"
import { PossibleAnswer } from "features/subscription-process/profiling-process/types/interfaces"
import { FC, useMemo } from "react"

interface GenericSurveyPreviewProps {
  surveyForm?: Record<string, PossibleAnswer>
}

export const GenericSurveyPreview: FC<GenericSurveyPreviewProps> = ({ surveyForm }) => {
  const { questionWithAnswers } = useGenericSurvey()
  const mappedSurvey = useMemo(() => questionWithAnswers(surveyForm), [questionWithAnswers, surveyForm])

  if (!mappedSurvey) {
    return <></>
  }

  return <div className="flex flex-col gap-4">
    {mappedSurvey.map((group, groupIndex) => (
      <CardsSection title={group.title} key={groupIndex}>
        {/* Questions du groupe */}
        <div className="space-y-2 bg-white rounded-xl border p-4">
          {group.questions.map((item, questionIndex) => (
            <div key={questionIndex} className="space-y-1">
              {/* Question */}
              <label className="text-lg font-medium">
                {item.question}
              </label>
              {/* Réponses */}
              <div className="space-y-2">
                {item.answers.map((answer: any, answerIndex: number) => (
                  <span key={answerIndex} className="font-light select-none">
                    {typeof answer === 'boolean' 
                      ? (answer ? 'Oui' : 'Non')
                      : answer
                    }
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CardsSection>
    ))}
  </div>
}
